export default __webpack_public_path__ + "static/8-ee00d3575c9d571ae1c60a77019c4cd3.png";